import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getActiveTrainingRoutine } from '~/api';
import Loading from '~/components/Loading';

function Home() {
  const [activeTrainingRoutine, setActiveTrainingRoutine] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const loadingUser = useSelector((state) => state.user.isLoading);
  const user = useSelector((state) => state.user.user);

  const getActiveTraining = async () => {
    const res = await getActiveTrainingRoutine();

    setActiveTrainingRoutine(res.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getActiveTraining();
  }, []);

  const redirect = () => {
    return user.role === 'ADMIN' ? (
      <Redirect to="/users" />
    ) : (
      <Redirect
        to={{
          pathname: activeTrainingRoutine
            ? `/users/${user.id}/training-routines/${activeTrainingRoutine.id}`
            : `/users/${user.id}/training-routines`,
          state: activeTrainingRoutine,
        }}
      />
    );
  };

  return !isLoading && !loadingUser ? redirect() : <Loading />;
}

export default Home;
